<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <div class="vx-row">
          <div class="vx-col w-full">
            <vx-card>
                <div slot="no-body">
                </div>
                <h5 class="mb-2"> Client </h5>
                    <div class="content-center">
                        <div class="vs-component vs-con-input-label vs-input mt-5 w-full vs-input-primary">
                            <label for="" class="vs-input--label mt-5">Client</label>
                            <vx-input-group class="">
                              <div class="flex">
                                  <v-select name="client_id" class="w-full mr-1" :clearable="false" label="fullName" v-model="dataIntervention.client_id" :options="Clients_choices" :reduce="client => client.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                  <div slot="no-options">
                                    <div class="btn-add-new p-2 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary "  @click="addNewClient">
                                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                                        <span class="ml-2 text-base text-primary">Ajouter nouveau client</span>
                                    </div>
                                  </div>
                                  </v-select>
                              </div>
                            </vx-input-group>
                        </div>

                        <!-- NAME -->

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Nom" v-model="dataIntervention.client.lastname" class="w-full" name="lastname"/>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Prénom" v-model="dataIntervention.client.firstname" class="w-full" name="firstname" />
                            </div>
                        </div>

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Entreprise" v-model="dataIntervention.client.company" class="w-full" name="company" />
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Siret" v-model="dataIntervention.client.siret" class="w-full" name="siret" />
                            </div>
                        </div>

                        <div class="vx-row mt-5">
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Email" v-model="dataIntervention.client.email" class="w-full" name="client_email" />
                              <span class="text-danger text-sm" v-show="errors.has('step-1.client_email')">{{ errors.first('step-1.client_email') }}</span>
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                              <vs-input label="Téléphone" v-model="dataIntervention.client.tel" class="w-full" name="client_tel" />
                              <span class="text-danger text-sm" v-show="errors.has('step-1.client_tel')">{{ errors.first('step-1.client_tel') }}</span>
                            </div>
                        </div>

                        <div class="vs-component vs-con-input-label vs-input mt-5 w-full vs-input-primary">
                          <label for="textarea-default" class="vs-input--label mt-5">Adresse</label>
                          <vs-textarea id="textarea-default" rows="3"  name="client_address" v-model="dataIntervention.client.address" />
                          <span class="text-danger text-sm" v-show="errors.has('step-1.client_address')">{{ errors.first('step-1.client_address') }}</span>
                        </div>

                        <div class="vx-row mt-5">
                          <div class="vx-col md:w-1/2 w-full">
                            <vs-input label="Ville" v-model="dataIntervention.client.city" class="w-full" name="client_city" />
                            <span class="text-danger text-sm" v-show="errors.has('step-1.client_city')">{{ errors.first('step-1.client_city') }}</span>
                          </div>
                          <div class="vx-col md:w-1/2 w-full">
                            <vs-input label="Code postal" v-model="dataIntervention.client.zipcode" class="w-full" name="client_zipcode" />
                            <span class="text-danger text-sm" v-show="errors.has('step-1.client_zipcode')">{{ errors.first('step-1.client_zipcode') }}</span>
                          </div>
                        </div>

                    </div>
            </vx-card>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vx-card>
              <h5 class="mb-2"> Photos </h5>
                <div class="content-center">
                  <silent-box ref="silentbox" :gallery="gallery" v-if="gallery.length">
                      <template v-slot:silentbox-item="{ silentboxItem }">
                          <img :src="silentboxItem.src" style="width: 200px !important;height: 150px !important;margin-right: 5px;border-radius: 5px;">
                          <!-- <vs-button color="danger" type="flat" class="w-full" @click.prevent="deleteImage(silentboxItem.id)"><feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" /> Supprimer</vs-button> -->
                      </template>
                  </silent-box>

                  <!-- <div class="vx-row mt-5">
                    <div class="vx-col w-full text-center">
                      <vs-button type="gradient" color="success" class="w-full" @click="showCamera = true">Ajouter photo</vs-button>
                    </div>
                  </div> -->

                </div>
            </vx-card>
          </div>
        </div>
        
        
      </div>

      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vx-card>
              <div slot="no-body">
              </div>
              <h5 class="mb-2">Intervention </h5>
              <div class="content-center">

                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Etat</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="etat_emergency" class="w-full" :clearable="false" label="label" v-model="dataIntervention.emergency" :options="Emergency_choices" :dir="$vs.rtl ? 'rtl' : 'ltr'" >

                          </v-select>
                          </div>
                          <span class="text-danger text-sm" v-show="errors.has('step-1.etat_emergency')">{{ errors.first('step-1.etat_emergency') }}</span>
                      </vx-input-group>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input vs-input-primary w-full">
                      <label  class="vs-input--label">Date</label><br/>
                      <flat-pickr :config="configdateTimePicker" v-model="dataIntervention.date" name="date_intervention" class="w-full"  />
                      <span class="text-danger text-sm" v-show="errors.has('step-1.date_intervention')">{{ errors.first('step-1.date_intervention') }}</span>
                    </div>
                  </div>
                </div>

                <div class="vx-row">
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-input label="Lieu " v-model="dataIntervention.lieu" class="w-full" name="lieu_intervention"  />
                    <span class="text-danger text-sm" v-show="errors.has('step-1.lieu_intervention')">{{ errors.first('step-1.lieu_intervention') }}</span>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                      <label for="" class="vs-input--label">Secteur</label>
                      <v-select class="w-full" name="secteur_id" label="name" v-model="dataIntervention.secteur_id" :options="Secteur_choices" :reduce="secteur => secteur.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <div slot="no-options">Désolé, aucun secteur correspondante.</div>
                      </v-select>
                    </div>
                  </div>
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Catégorie</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="categorie_intervention" class="w-full " :clearable="false" label="name" v-model="dataIntervention.categorie" :options="Services_choices" :reduce="service => service.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                              <div slot="no-options">Désolé, aucune catégorie correspondante.</div>
                          </v-select>
                          </div>
                          <span class="text-danger text-sm" v-show="errors.has('step-1.categorie_intervention')">{{ errors.first('step-1.categorie_intervention') }}</span>
                      </vx-input-group>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Type de problème</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="sub_categorie_intervention" class="w-full " :clearable="false" label="titre" v-model="dataIntervention.subcategorie" :options="SubServices_choices_filtred" :reduce="subservice => subservice.id" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                              <div slot="no-options">Désolé, aucune type correspondante.</div>
                          </v-select>
                          </div>
                          <span class="text-danger text-sm" v-show="errors.has('step-1.sub_categorie_intervention')">{{ errors.first('step-1.sub_categorie_intervention') }}</span>
                      </vx-input-group>
                    </div>
                  </div>
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col md:w-1/2 w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="" class="vs-input--label">Etat</label>
                      <vx-input-group class="mb-base">
                          <div class="flex">
                          <v-select name="etat_intervention" class="w-full " :clearable="false" label="label" v-model="dataIntervention.status" :options="Status_choices" :dir="$vs.rtl ? 'rtl' : 'ltr'" >
                              <div slot="no-options">Désolé, aucune etat correspondante.</div>
                          </v-select>
                          </div>
                          <span class="text-danger text-sm" v-show="errors.has('step-1.etat_intervention')">{{ errors.first('step-1.etat_intervention') }}</span>
                      </vx-input-group>
                    </div>
                  </div>
                  <div class="vx-col md:w-1/2 w-full">
                    <vs-input label="Prix annoncé" v-model="dataIntervention.price" class="w-full" />
                  </div>
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="textarea-default" class="vs-input--label ">Description problème</label>
                      <vs-textarea  rows="3"  name="description_intervention" v-model="dataIntervention.description"  />
                      <span class="text-danger text-sm" v-show="errors.has('step-1.description_intervention')">{{ errors.first('step-1.description_intervention') }}</span>
                    </div>
                  </div>
                  
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="textarea-default" class="vs-input--label ">Commentaire</label>
                      <vs-textarea  rows="3"  name="description_intervention" v-model="dataIntervention.note"  />
                    </div>
                  </div>
                </div>

                <div class="vx-row mt-5">
                  <div class="vx-col w-full">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                      <label for="textarea-default" class="vs-input--label" @click="artisansPopupActive = true">
                        Les artisans affectés
                        <vs-button class="float-right mb-5" color="primary" type="flat"><feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Affecter artisans</vs-button>
                      </label>

                      <vs-popup fullscreen title="Affecter des artisans" :active.sync="artisansPopupActive">

                        <vs-table ref="table"  multiple v-model="dataIntervention.artisans" pagination :max-items="itemsPerPage" :data="filteredArtisansItems" noDataText="Aucun artisan trouvé">
                          <div slot="header" class=" flex-wrap-reverse items-center flex-grow justify-between">

                            <div class="vx-row w-full mb-2">
                              <div class="vx-col md:w-1/6 w-full">
                                <vs-input label="Nom & prénom" v-model="f_search" class=" mr-1 w-full" name="search" />
                              </div>

                              <div class="vx-col md:w-1/6 w-full">
                                <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                                    <label for="" class="vs-input--label">Competences</label>
                                    <v-select multiple class="w-full" name="service_ids" :clearable="false" label="name" v-model="f_services_id" :options="Services_choices" :reduce="service => service.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                      <div slot="no-options">Désolé, aucune service correspondante.</div>
                                    </v-select>
                                </div>
                              </div>

                              <div class="vx-col md:w-1/6 w-full">
                                <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                                  <label for="" class="vs-input--label" >Disponibilites</label>
                                  <v-select name="disponibilites" class="ml-1" :clearable="false" label="name" v-model="f_disponibilites" :options="['Tous','24h24 7j7','Journée uniquement','Soir et week-end']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <div slot="no-options">Désolé, aucune service correspondante.</div>
                                  </v-select>
                                </div>
                              </div>

                              <div class="vx-col md:w-1/6 w-full">
                                <div class="vs-component vs-con-input-label vs-input  w-full vs-input-primary">
                                  <label for="" class="vs-input--label">Secteurs</label>
                                  <v-select multiple class="w-full" name="secteur_ids" :clearable="false" label="name" v-model="f_secteurs_id" :options="Secteur_choices" :reduce="secteur => secteur.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                      <div slot="no-options">Désolé, aucun secteur correspondante.</div>
                                  </v-select>
                                </div>
                              </div>

                            </div>

                          </div>

                          <template slot="thead">
                            <vs-th sort-key="lastname">Noms & Prénoms</vs-th>
                            <vs-th sort-key="tel">Télephones</vs-th>
                            <vs-th sort-key="services">Competences</vs-th>
                            <vs-th sort-key="availability">Disponibilites</vs-th>
                            <vs-th sort-key="ville">Ville</vs-th>
                            <vs-th sort-key="secteurs">Secteurs</vs-th>
                            <vs-th>Action</vs-th>
                          </template>

                            <template slot-scope="{data}">
                              <tbody>
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                                  <vs-td>
                                    <p @click.stop="editData(tr)">{{ tr.lastname }} {{ tr.firstname }}</p>
                                  </vs-td>

                                  <vs-td>
                                    <p>{{ tr.tel }}</p>
                                  </vs-td>

                                  <vs-td>
                                    <p  >
                                      <span :key="indexSer" v-for="(service, indexSer) in tr.services">
                                      <vs-chip color="primary">{{ service.name }}</vs-chip>
                                      </span>
                                      </p>
                                  </vs-td>

                                  <vs-td>
                                    <p>{{ tr.availability }}</p>
                                  </vs-td>

                                  <vs-td>
                                    <p>{{ tr.city.name }}</p>
                                  </vs-td>

                                  <vs-td>
                                    <p  >
                                      <span :key="indexSer"  v-for="(secteur, indexSer) in tr.secteurs">
                                      <vs-chip color="primary">{{ secteur.name }}</vs-chip>
                                      </span>
                                      </p>
                                  </vs-td>

                                  <vs-td class="whitespace-no-wrap">
                                    <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editData(tr)"/>
                                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="deleteData(tr.id)"/>
                                  </vs-td>

                                </vs-tr>
                              </tbody>
                            </template>
                        </vs-table>
                      </vs-popup>

                      <vs-table :data="dataIntervention.artisans" noDataText="Aucun artisan affecté ">

                        <template slot="thead">
                          <vs-th>Noms & prénoms</vs-th>
                          <vs-th>Télephones</vs-th>
                          <vs-th>Competences</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                              {{ tr.lastname }} {{ tr.firstname }}
                            </vs-td>
                            <vs-td >
                              {{ tr.tel }}
                            </vs-td>
                            <vs-td >
                                <p>
                                  <span :key="indexSer"  v-for="(service, indexSer) in tr.services">
                                    <vs-chip color="primary">{{ service.name }}</vs-chip>
                                  </span>
                                </p>
                            </vs-td>

                              <template class="expand-user" slot="expand">
                                <div class="con-expand-users w-full">
                                  <div class="con-btns-user flex items-center justify-between">
                                    <vs-list>
                                      <vs-list-item :title="'Siret : '+tr.siret"></vs-list-item>
                                      <vs-list-item :title="'Disponibilites : '+ tr.availability"></vs-list-item>
                                      <vs-list-item :title="'Note : '+ tr.score + ' /5'"></vs-list-item>
                                    </vs-list>
                                  </div>
                                </div>
                              </template>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </div>

              </div>

          </vx-card>

          
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full text-right">
        <vs-button type="gradient" @click="saveClientAndInterventionData()">{{ dataIntervention.id ? 'Mettre à jour l\'intervention' : 'Créer l\'intervention' }}</vs-button>
      </div>
    </div>

    <div class="vx-row mt-5" v-if="user_role === 'Admin'">
      <div class="vx-col w-full">
        <vx-card>
          <h5 class="mb-2"> Historiques </h5>
            <div class="content-center">
              <vx-timeline class="mt-10" :data="dataIntervention ? dataIntervention.historiques : []" />
            </div>
        </vx-card>
      </div>
    </div>

    <!-- <camera :isSidebarActive="showCamera" @closeSidebar="showCamera = false" :intervention_id="dataIntervention.id" @addImage="addImage($event)" /> -->
  </div>
</template>

<script src="https://unpkg.com/vue@next"></script>
<script src="https://unpkg.com/vue-easy-lightbox@next/dist/vue-easy-lightbox.umd.min.js"></script>
<script>
import vSelect from 'vue-select'
import { VueEditor } from "vue2-editor"
import { mapActions, mapGetters } from 'vuex'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { French } from 'flatpickr/dist/l10n/fr.js'

import VueSilentbox from 'vue-silentbox'
import camera from './camera'

import VxTimeline from "@/components/timeline/VxTimeline"

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
  custom: {
    date_intervention: {
      required: 'La date d\'intervention est obligatoire'
    },
    lieu_intervention: {
      required: 'Le lieu d\'intervention est obligatoire'
    },
    description_intervention: {
      required: 'La description de problème est obligatoire'
    },
    categorie_intervention : {
      required: 'La catégorie d\'intervention est obligatoire'
    },

    client_email : {
      required: 'L\'email de client est obligatoire'
    },
    client_tel : {
      required: 'Le téléphone de client est obligatoire'
    },
    client_city : {
      required: 'La ville de client est obligatoire'
    },
    client_zipcode : {
      required: 'Le code postal de client est obligatoire'
    },
    client_address : {
      required: 'L\'adresse de client est obligatoire'
    },
    sub_categorie_intervention: {
      required: 'Le type de problème est obligatoire'
    }


  }
};

// register custom messages
Validator.localize('fr', dict);

export default {

  components: {
    vSelect,
    flatPickr,
    VueEditor,
    VueSilentbox,
    camera,
    VxTimeline,
  },
  props: ['dataIntervention'],
  data () {
    return {
      user_role : null,
      id: null,
      artisansPopupActive: false,
      configdateTimePicker: {
        locale: French,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      Status_choices : [
        {label: 'En attente', value: 0},
        {label: 'Valider', value: 1},
        {label: 'En cours', value: 2},
        {label: 'Terminer', value: 3},
        {label: 'Refuser', value: 4},
        {label: 'Annuler - trop chère', value: 5},
        {label: 'Annuler - artisan non disponible', value: 6},
        {label: 'Annuler - client annule', value: 7},
        {label: 'Annuler - hors secteur', value: 8},
        {label: 'Annuler - concurrence', value: 9},

      ],
      Emergency_choices : [
        {label: 'En urgence', value: 1},
        {label: 'Sur rendez-vous', value: 0}
      ],
      itemsPerPage: 10,
      f_services_id: null,
      f_secteurs_id: null,
      f_disponibilites: 'Tous',
      f_city_id: null,
      f_search: "",
      first_load: true,

      showCamera: false,
      gallery: [],
      timelineData: [],
    }
  },
  created () {
    this.user_role = this.$cookies.get('role')

    this.fetchArtisans()
    this.fetchClients()
    this.fetchServices()
    this.fetchSubServices()
    this.fetchSecteur()
    this.fetchInterventions()
  },
  computed: {
    ...mapGetters('artisans', {'Artisan_choices' : 'GET_ITEMS'}),
    ...mapGetters('clients', {'Clients_choices' : 'GET_ITEMS'}),
    ...mapGetters('services', {'Services_choices' : 'GET_ITEMS'}),
    ...mapGetters('subservices', {'SubServices_choices' : 'GET_ITEMS'}),
    ...mapGetters('secteurs', {'Secteur_choices' : 'GET_ITEMS'}),
    ...mapGetters('interventions', {'interventions' : 'GET_ITEMS','intervention' : 'GET_ITEM','historiques' : 'GET_ITEMS_HISTORIQUES_BY_INTERVENTION'}),

    SubServices_choices_filtred() {
      return this.SubServices_choices.filter(subservice => {
        return subservice.service_id == (this.dataIntervention.categorie ? this.dataIntervention.categorie : -1)
      })
    },

    filteredArtisansItems() {
      let dataFilter = null
      if(this.f_services_id == null || this.f_services_id.length == 0) {
        dataFilter = this.Artisan_choices
      }else{
        dataFilter = this.Artisan_choices.filter(item => {
          return item.services.findIndex(service => (this.f_services_id.includes(service.id))) > -1
        })
      }

      if(this.f_secteurs_id != null && this.f_secteurs_id.length > 0) {
       dataFilter = dataFilter.filter(item => {
          return item.secteurs.findIndex(secteur => (this.f_secteurs_id.includes(secteur.id))) > -1
        })
      }

      if(this.f_disponibilites != 'Tous'){
        dataFilter = dataFilter.filter(item => {
          return item.availability.indexOf(this.f_disponibilites) > -1
        })
      }

      if(this.f_search != null && this.f_search != "") {
        dataFilter = dataFilter.filter(item => {
          return item.lastname.trim().toLowerCase().concat(' ',item.firstname.trim().toLowerCase()).includes(this.f_search.toLowerCase()) || item.firstname.trim().toLowerCase().concat(' ',item.lastname.trim().toLowerCase()).includes(this.f_search.toLowerCase())
        })
      }

      return dataFilter

    }
  },
  methods: {
    ...mapActions('artisans', {'fetchArtisans': 'fetchItems'}),
    ...mapActions('clients', {'fetchClients':'fetchItems', 'addClient' : 'addItem', 'updateClient' : 'updateItem'}),
    ...mapActions('services', {'fetchServices':'fetchItems'}),
    ...mapActions('subservices', {'fetchSubServices':'fetchItems'}),
    ...mapActions('interventions', {'addIntervention':'addItem', 'getIntervention':'getItem', 'updateIntervention':'updateItem', 'fetchInterventions':'fetchItems', 'fetchImages' : 'fetchImages','removeImage' : 'removeImage','historiques' : 'fetchItemsHistoriquesByIntervetion'}),
    ...mapActions('secteurs', {'fetchSecteur' : 'fetchItems'}),

    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then(result => {
          if (result) {
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then(result => {
          if (result) {
            alert("Form submitted!");
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-4").then(result => {
          if (result) {
            alert("Form submitted!");
            resolve(true)
          } else {
            reject("correct all values");
          }
        })
      })
    },

    addNewClient() {
      this.dataIntervention.client_id = null
      this.dataIntervention.client = {
        id: null,
        address: null,
        company: null,
        email: null,
        firstname: null,
        lastname: null,
        siret: null,
        status: null,
        tel: null,
        city: null,
        zipcode: null,
        emergency: null
      }
      this.errors.items = []
    },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    addInterventionData() {
      this.addIntervention(this.dataIntervention).then(result => {
        this.dataIntervention.id = result.data.intervention.id
        this.successMsg("L'ajout","L'intervention est bien ajouté");
        this.$router.push(`/intervention/${result.data.intervention.id}`);
      }).catch(() => {
        this.errorMsg('L\'Ajout','Trouvé un error lor de l\'insertion')
      })
    },

    updateInterventionData() {
      this.updateIntervention(this.dataIntervention).then(() => {
        this.successMsg("Modification","L'intervention' est bien modifié");
      }).catch(() => {
        this.errorMsg('Modification','Trouvé un error lor de la modification')
      })
    },

    saveClientAndInterventionData() {
      this.$validator.validateAll('step-1').then(result => {
        if (result) {
          this.$emit('showLoading')
          if(this.dataIntervention.client_id) {
            this.updateClient(this.dataIntervention.client).then(() => {
              if(this.dataIntervention.id){
                this.updateInterventionData()
              }else{
                this.addInterventionData()
              }

              this.$emit('closeLoading')
            }).catch(err => {
              this.$emit('closeLoading')
              this.errorMsg('Modification de client','Trouvé un error lor de la modification de client')
            })
          }else{
            this.addClient(this.dataIntervention.client).then((result) => {
              this.dataIntervention.client_id = result.data.client.id
              this.addInterventionData()
              this.$emit('closeLoading')
            }).catch(err => {
              this.$emit('closeLoading')
              this.errorMsg('L\'Ajout','Trouvé un error lor de l\'insertion de client')
            })
          }
          return true
        } else {
          return false
        }
      })
    },

    showImg(index) {
      this.index = index
      this.visible = true
    },

    handleHide() {
      this.visible = false
    },

    addImage(image) {
      this.gallery.push(image)
    },

    deleteImage(id) {
      this.removeImage(id).then(() => {
        const ItemIndex = this.gallery.findIndex((p) => p.id == id)
        this.gallery.splice(ItemIndex, 1)
        this.$refs.silentbox.hideOverlay()
        this.successMsg("Supprission photo","La photo est bien supprimé");
      }).catch(() => {
        this.errorMsg('Supprission photo','Trouvé un error lor de la supprission')
      })
    }

  },

  //  beforeUpdate() {
  //   console.log("***********dd:",this.dataIntervention.id)
  //     this.historiques(this.dataIntervention.id)
  // },
  watch: {
    'dataIntervention.client_id'(val) {
      if(val) {
        let client = this.Clients_choices[this.Clients_choices.findIndex((client) => client.id == this.dataIntervention.client_id)]

        this.dataIntervention.client = {
          id: client.id,
          address: client.address,
          company: client.company,
          email: client.email,
          firstname: client.firstname,
          lastname: client.lastname,
          siret: client.siret,
          status: client.status,
          tel: client.tel,
          city: client.city,
          zipcode: client.zipcode,
          emergency: client.emergency
        }
      }
    },

    'dataIntervention.id'(val) {
      this.$emit('changeId', val)
      if(!val) this.errors.items = []

      this.fetchImages(val).then(response => {
        this.gallery = response.data
      })
    },

    'dataIntervention.categorie'() {
      if(this.SubServices_choices_filtred.findIndex(subservice => subservice.id == this.dataIntervention.subcategorie) == -1)
        this.dataIntervention.subcategorie = null
    },
    'dataIntervention.subcategorie'(val) {

        if(!this.first_load || !this.dataIntervention.id) {
          let montant = val ? this.SubServices_choices_filtred[this.SubServices_choices_filtred.findIndex(subservice => subservice.id == val)].montant : null
          this.dataIntervention.price = montant
        }

        this.first_load = false
    },
    'dataIntervention.client.city'(val) {
      this.dataIntervention.lieu = val
    }
  }

}
</script>
<style>
  .vs__selected{
    text-transform: uppercase;
  }

  #silentbox-overlay {
    z-index: 99999 !important;
  }

  .vs-sidebar.vs-sidebar-primary.vs-sidebar-position-right {
    z-index: 99999 !important;
    max-width: 500px !important;
  }
</style>
